import { useCallback } from 'react';

import NotesHeader from './components/NotesHeader';
import NotesSection from './components/NotesSection';
import NotesListBase from './components/NotesList';
import useNotesForAnchor from './hooks/useNotesForAnchor';

const Header = () => <NotesHeader title="Layer Feature Notes" />;

/**
 * Displays the Notes for a LayerFeature.
 */
const LayerFeatureNotes = ({ layerFeatureId }) => {
  const notes = useNotesForAnchor(layerFeatureId);

  const NotesList = useCallback(() => <NotesListBase notes={notes} />, [notes]);

  return (
    <NotesSection
      anchorId={layerFeatureId}
      Header={Header}
      NotesList={NotesList}
    />
  );
};

export default LayerFeatureNotes;
